import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { LocalService } from "app/services/local.service";
import { environment } from "environments/environment";
import { Observable, Subject } from "rxjs";
import { map } from "rxjs/operators";

@Injectable({
  providedIn: "root",
})
export class SupportService {
  myMethod$: Observable<any>;
  private getRatingData = new Subject<any>();
  apiUrl = "";
  // JSON.parse(localStorage.getItem('client'))['apiUrl'] || environment.apiUrl;

  constructor(
    private http: HttpClient,
    public localService: LocalService,
  ) {
    if (localStorage.getItem("client")) {
      this.apiUrl = JSON.parse(localStorage.getItem("client"))["apiUrl"];
    } else {
      this.apiUrl = environment.apiUrl;
    }
  }

  getSupportList(search): Promise<any> {
    const headers = new HttpHeaders({
      "Content-Type": "application/json",
      "x-access-token": localStorage.getItem("token"),
    });
    return this.http
      .post(
        this.apiUrl + "aggregator/listing-analytics/getSupportList",
        search,
        {
          headers: headers,
        },
      )
      .map((response) => response)
      .toPromise();
  }

  changeStatus(id, data): Promise<any> {
    const headers = new HttpHeaders({
      "Content-Type": "application/json",
      "x-access-token": localStorage.getItem("token"),
    });
    return this.http
      .post(this.apiUrl + "customerSupport/updateSupportStatus/" + id, data, {
        headers: headers,
      })
      .map((response) => response)
      .toPromise();
  }

  supportUpdateReply(supportID, data) {
    const headers = new HttpHeaders({
      "Content-Type": "application/json",
      "x-access-token": localStorage.getItem("token"),
    });
    return this.http
      .post(this.apiUrl + "customerSupport/updateSupport/" + supportID, data, {
        headers: headers,
      })
      .map((response) => response)
      .toPromise();
  }
  filterSupportId(term) {
    const headers = new HttpHeaders({
      "Content-Type": "application/json",
      "x-access-token": localStorage.getItem("token"),
    });
    let search = {
      supportId: term.toUpperCase(),
    };
    // console.log(search);
    return this.http
      .post(
        this.apiUrl + "aggregator/listing-analytics/getSupportList",
        search,
        {
          headers: headers,
        },
      )
      .pipe(
        map((response) =>
          response["Data"].filter((option) => {
            return search;
          }),
        ),
      );
  }
 // NEWS LETTER API
  getNewsletterSubscribers(page, limit, search: any = {}): Promise<any> {

  const headers = new HttpHeaders({
    "Content-Type": "application/json",
    "x-access-token": localStorage.getItem("token"),
  });

  let url =
    this.apiUrl +
    `customer/subscribedEmail?page=${page}&limit=${limit}`;

  if (search?.email) {
    url += `&email=${search.email}`;
  }

  return this.http
    .get(url, { headers })
    .pipe(map((response) => response))
    .toPromise();
}

 // CONTACTUS LIST API 
  getContactUsList(page: number, limit: number, search: any = {}): Promise<any> {

  const headers = new HttpHeaders({
    "Content-Type": "application/json",
    "x-access-token": localStorage.getItem("token"),
  });

  let url =
    this.apiUrl +
    `customerSupport/getContactUsMsg?start=${page}&limit=${limit}`;

  if (search?.name) {
    url += `&name=${search.name}`;
  }

  if (search?.email) {
  url += `&mailID=${search.email}`;
}

  if (search?.phone) {
    url += `&phone=${search.phone}`;
  }

  return this.http
    .get(url, { headers })
    .pipe(map((response) => response))
    .toPromise();
 }

}
